import landingService from "@/api/services/landingService";
import { Landing } from "@/interfaces/Landing.ts";
import { defineStore } from "pinia";
import { useFeatureStore } from "@/store/feature.ts";
import { SFW_LANDING_IDS } from "@/utils/variables.ts";

interface LandingPageState {
  landingPages: Record<number, Landing>;
}

export const useLandingStore = defineStore("landing", {
  state: (): LandingPageState => ({
    landingPages: {},
  }),

  getters: {
    getLandingPageById: (state: LandingPageState) => (id: number) => state.landingPages[id],
    getDefaultLandingPage: (state: LandingPageState) => (lang: string) => {
      if (useFeatureStore().hasAgeVerificationFeature) {
        return state.landingPages[SFW_LANDING_IDS[lang as "en" | "de" | "fr"]];
      }

      const landingLang = lang === "de" ? lang : "en";

      for (const id in state.landingPages) {
        const landing = state.landingPages[id];

        if (landing.default && landing.language === landingLang) {
          return landing;
        }
      }

      return null;
    },
  },

  actions: {
    setLandingPage(landing: Landing) {
      const newLanding: Record<number, Landing> = {};
      newLanding[landing.id] = landing;

      this.landingPages = {
        ...this.landingPages,
        ...newLanding,
      };
    },
    async fetchLandingPage(payload: { id?: number; lang?: string }) {
      const landing = await landingService.getLandingPage(payload);

      const newLanding: Record<number, Landing> = {};
      newLanding[landing.id] = landing;

      this.landingPages = {
        ...this.landingPages,
        ...newLanding,
      };

      return landing;
    },
  },
});
